namespace TabAurous.OMS {
    export interface CollectionMasterForm {
        AttributeTypeId: Serenity.IntegerEditor;
        AttributeCode: Serenity.StringEditor;
        AttributeName: Serenity.StringEditor;
    }

    export class CollectionMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.CollectionMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CollectionMasterForm.init)  {
                CollectionMasterForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CollectionMasterForm, [
                    'AttributeTypeId', w0,
                    'AttributeCode', w1,
                    'AttributeName', w1
                ]);
            }
        }
    }
}
